import { render, staticRenderFns } from "./SideBarMenu.vue?vue&type=template&id=73cbff32&scoped=true&"
import script from "./SideBarMenu.vue?vue&type=script&lang=js&"
export * from "./SideBarMenu.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=73cbff32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cbff32",
  null
  
)

export default component.exports